import { getEnvVar } from '@nucleus/lib-environment';
import { deepFreeze } from '@nucleus/src-platform/lib/deepFreeze';
import { COLOR_MODE_AUTO, COLOR_MODE_LIGHT, STANDARD_COLOR_DEFAULT } from './color';

export const NUCLEUS_LAUNCHER_URL = getEnvVar('NUCLEUS_LAUNCHER_URL');
export const NUCLEUS_LAUNCHER_URL_PARAM = getEnvVar('NUCLEUS_LAUNCHER_URL_PARAM', 'nucleuslauncher');

export const LAUNCHER_ORIGIN_WHITELIST = Object.freeze(
  getEnvVar('LAUNCHER_ORIGIN_WHITELIST', '')
    .toLowerCase()
    .split(',')
    .map((origin) => origin.trim())
);

export const LAUNCHER_DB_TYPE_URL = 'url';

export const PREFER_LARGER = 'PREFER_LARGER';
export const PREFER_SMALLER = 'PREFER_SMALLER';
export const PREFERRED_SIZES = deepFreeze([PREFER_LARGER, PREFER_SMALLER]);

export const TRIGGER_ICON_NUCLEUS = 'nucleus';
export const TRIGGER_ICON_NEXT_STEPS = 'next-steps';
export const TRIGGER_ICON_FOOT_PRINTS = 'foot-prints';
export const TRIGGER_ICON_PLUS = 'plus';
export const TRIGGER_ICON_GIVE = 'give';
export const TRIGGER_ICON_REBELGIVE = 'rebelgive';
export const TRIGGER_ICON_GIVING_HAND = 'giving-hand';
export const TRIGGER_ICON_GIVING_HEART = 'giving-heart';

export const TRIGGER_ICONS = Object.freeze([
  TRIGGER_ICON_NUCLEUS,
  TRIGGER_ICON_NEXT_STEPS,
  TRIGGER_ICON_FOOT_PRINTS,
  TRIGGER_ICON_PLUS,
  TRIGGER_ICON_GIVE,
  TRIGGER_ICON_REBELGIVE,
  TRIGGER_ICON_GIVING_HAND,
  TRIGGER_ICON_GIVING_HEART,
]);

export const TRIGGER_ICONS_LAUNCHER = Object.freeze([
  TRIGGER_ICON_NUCLEUS,
  TRIGGER_ICON_NEXT_STEPS,
  TRIGGER_ICON_FOOT_PRINTS,
  TRIGGER_ICON_PLUS,
]);

export const TRIGGER_ICONS_FLOW = Object.freeze([
  TRIGGER_ICON_GIVE,
  TRIGGER_ICON_REBELGIVE,
  TRIGGER_ICON_GIVING_HAND,
  TRIGGER_ICON_GIVING_HEART,
]);

export const TRIGGER_POSITION_LEFT = 'left';
export const TRIGGER_POSITION_CENTER = 'center';
export const TRIGGER_POSITION_RIGHT = 'right';
export const TRIGGER_POSITIONS = deepFreeze([TRIGGER_POSITION_LEFT, TRIGGER_POSITION_CENTER, TRIGGER_POSITION_RIGHT]);

export const TRIGGER_SHAPE_PILL = 'pill';
export const TRIGGER_SHAPE_ROUNDED = 'rounded';
export const TRIGGER_SHAPE_CIRCLE = 'circle';
export const TRIGGER_SHAPES = deepFreeze([TRIGGER_SHAPE_PILL, TRIGGER_SHAPE_ROUNDED, TRIGGER_SHAPE_CIRCLE]);

export const CONNECTION_TYPE_NONE = 'CONNECTION_TYPE_NONE';

export const LAUNCHER_DEFAULTS = Object.freeze({
  items: [],
  featured_items: [],
  color_flow: STANDARD_COLOR_DEFAULT,
  color_mode: COLOR_MODE_AUTO,
  title: 'Take your next step here',
  title_search: '',
  preferred_size: PREFER_SMALLER,
  discovery_message_title: 'Take your next step here',
  discovery_message_byline: 'Pray, give, join a group, and more!',
  featured_item_callout: {
    enabled: false,
  },
  trigger_icon: TRIGGER_ICON_NUCLEUS,
  trigger_position: TRIGGER_POSITION_RIGHT,
});

// WARNING: Never modify fallback values
export const LAUNCHER_FALLBACKS = Object.freeze({
  actions: [],
  color_flow: STANDARD_COLOR_DEFAULT,
  color_mode: COLOR_MODE_LIGHT,
  discovery_message_byline: 'Pray, give, join a group, and more!',
  discovery_message_title: 'Take your next step here',
  featured_item_callout: {
    enabled: false,
  },
  featured_items: [],
  preferred_size: PREFER_SMALLER,
  title: 'Take your next step here',
  title_search: '',
  trigger_icon: TRIGGER_ICON_NUCLEUS,
  trigger_offset_bottom: '',
  trigger_offset_side: '',
  trigger_position: TRIGGER_POSITION_RIGHT,
  trigger_zindex: '',
});

export const enum LAUNCHER_ITEM_TYPE {
  Button = 'button',
  Collection = 'collection',
  Info = 'info',
}

export const GIVING_DESTINATION_GIVINGFLOW = 'givingflow';
export const PRAYER_DESTINATION_PRAYERFLOW = 'prayerflow';
export const PRAYER_DESTINATION_PRAYERWALL = 'prayerwall';

export const enum LAUNCHER_LOCATION {
  Web = 'web',
  Hosted = 'hosted',
}

export const enum BANNER_STATUS {
  Draft = 'draft',
  Active = 'active',
}

export const enum BANNER_TYPE {
  Inline = 'inline',
  Floating = 'floating',
  Fullscreen = 'fullscreen',
  Popup = 'popup',
}

export const enum BANNER_DISMISSIBLE_INTERVAL {
  Infinite = 'infinite',
  Day = 'day',
  Minute = 'minute',
}

export const enum BANNER_SCHEDULE_TYPE {
  OneTime = 'OneTime',
  Recurring = 'Recurring',
}

export const enum BANNER_SCHEDULE_RECURRENCE {
  Weekly = 'Weekly',
}

export const enum BANNER_MEDIA_TYPE {
  Image = 'image',
  Emoji = 'emoji',
}

export const enum BANNER_ACTION_TYPE {
  Flow = 'flow',
  Giving = 'giving',
  InfoCard = 'infocard',
  None = 'none',
  Page = 'page',
  Prayer = 'prayer',
  PrayerHub = 'prayerhub',
  Url = 'url',
}

export const enum INFOCARD_TYPE {
  Standard = 'standard',
}
